import { Component, Input, Output } from '@angular/core';

@Component({
	selector: 'pagination',
	templateUrl: 'pagination.component.html'
})
export class PaginationComponent {
	@Input() pagination: any;
}